import React from 'react'
import { Badge, Skeleton, Typography } from 'antd'
import { MetricKey, METRICS, SummaryData } from './types'

const { Text } = Typography

interface CampaignTotalsSummaryProps {
  selectedCampaignIds: string[]
  selectedMetrics: MetricKey[]
  summaryData: SummaryData | null
  summaryLoading: boolean
  className?: string
}

export const CampaignTotalsSummary: React.FC<CampaignTotalsSummaryProps> = ({
  selectedCampaignIds,
  selectedMetrics,
  summaryData,
  summaryLoading,
  className = ''
}) => {
  if (selectedCampaignIds.length === 0) {
    return (
      <div className={`bg-gray-50 rounded-lg p-4 h-fit min-w-[280px] ${className}`}>
        <Text strong className="block mb-3">Campaign Totals</Text>
        <Text type="secondary" className="text-sm">Select campaigns to view totals</Text>
      </div>
    )
  }

  return (
    <div className={`bg-gray-50 rounded-lg p-4 h-fit min-w-[280px] ${className}`}>
      <Text strong className="block mb-3">Campaign Totals</Text>
      {summaryLoading ? (
        <div className="grid grid-cols-2 gap-x-4 gap-y-3">
          {selectedMetrics.map(metricKey => {
            const metric = METRICS.find(m => m.key === metricKey)
            if (!metric) return null
            return (
              <div key={metric.key} className="flex flex-col">
                <div className="text-xs text-gray-600 mb-1">{metric.label}</div>
                <Skeleton.Button size="small" active className="w-full" />
              </div>
            )
          })}
        </div>
      ) : summaryData ? (
        <div className="grid grid-cols-2 gap-x-4 gap-y-3">
          {selectedMetrics.map(metricKey => {
            const metric = METRICS.find(m => m.key === metricKey)
            if (!metric) return null
            return (
              <div key={metric.key} className="flex flex-col">
                <div className="text-xs text-gray-600 mb-1">{metric.label}</div>
                <div className="text-sm font-medium">
                  {metric.formatter(summaryData[metric.key] || 0)}
                </div>
              </div>
            )
          })}
        </div>
      ) : (
        <Text type="secondary" className="text-sm">No data available</Text>
      )}
    </div>
  )
}
